<div class="menu-container" [class.collapsed]="isCollapsed()">
  <div class="logo-container">
    <img src="/assets/images/quantol.io logo.svg" [class.hidden]="isCollapsed()" alt="Quantrol Logo" class="logo full-logo">
    <img src="/assets/images/Q icon.svg" [class.hidden]="!isCollapsed()" alt="Quantrol Logo" class="logo icon-logo">
  </div>
  <div *ngIf="false" class="">
    <ng-select
      [items]="tenants"
      bindLabel="companyName"
      bindValue="tenantKey"
      [(ngModel)]="selectedTenant"
      [ngModelOptions]="{standalone: true}"
      (change)="changeTenant($event)"
      [clearable]="false"
      [searchable]="false"
      class="tenant-select"
      ></ng-select>
  </div>
  <nav class="side-menu">
    <ul>
      <li *ngFor="let item of menuItems; let i=index" [title]="item.name">
        @if (hasPermission(item.requiredRoles) ) {
          <a [class.collapsedA]="isCollapsed()" routerLink="{{item.path}}" routerLinkActive="active">
            <img [src]="item.icon" alt="{{item.name}} icon" class="menu-icon">
            <span class="menu-text">{{item.name}} <i (click)="toggleChilds(i)" *ngIf="item.childs?.length > 0 && !item.showChilds" class="fa fa-angle-down"></i><i (click)="toggleChilds(i)" *ngIf="item.childs?.length > 0 && item.showChilds" class="fa fa-angle-up"></i></span>
          </a>
          @if (item.childs?.length > 0 && item.showChilds && !isCollapsed()) {
            <ul class="submenu">
              <li *ngFor="let child of item.childs" [title]="child.name">
                @if (hasPermission(child.requiredRoles) ) {
                  <a routerLink="{{item.path+child.path}}" routerLinkActive="active">
                    <span class="border-container" ><span class="border-section"></span></span>
                    <span class="sub-menu-text">{{child.name}}</span>
                  </a>
                }
              </li>
            </ul>
          }
        }
      </li>
    </ul>
    @if(isCollapsed()) {
    <div class="sidebar-footer collapsed-footer" >
        <a class="justify-content-center">
          <!-- <span class="footer-name" (click)="logout()" routerLink="/">{{data[0].name}}</span> -->
          <!-- <span class="footer-name fw-bold" (click)="logout()" routerLink="/">{{firstName | uppercase}} {{lastName | uppercase}}
          </span> -->
         <img class="log-out-btn " src="/assets/icons/log out rateloc mobile (black).svg" (click)="logout()" routerLink="/" >

        </a>
      </div>

       } @else {
    <div class="sidebar-footer" >

        <a>
          <!-- <span class="footer-name" (click)="logout()" routerLink="/">{{data[0].name}}</span> -->
          <span class="footer-name fw-bold" (click)="logout()" routerLink="/">{{firstName | uppercase}} {{lastName | uppercase}}
          </span>
         <img class="log-out-btn" src="/assets/icons/log out rateloc mobile (black).svg" (click)="logout()" routerLink="/" >

        </a>
    </div>

       }

  </nav>
  <button class="toggle-btn" (click)="toggleMenu()">
         @if(isCollapsed()) {
          <i class="fa-solid fa-arrow-right-long"></i>
         } @else {
          <i class="fa-solid fa-arrow-left-long"></i>
         }
  </button>
</div>
